import { Alert, AlertColor, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useUserMessageStore } from '../../stores';

function MessageToast() {
  const clearMessages = useUserMessageStore.use.clearMessages();
  const userMessage = useUserMessageStore.use.userMessage();
  const messageType = useUserMessageStore.use.messageType();

  const handleClose = () => {
    clearMessages();
  };

  const action = (
    <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      open={!!userMessage}
      autoHideDuration={8000}
      onClose={handleClose}
      action={action}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={messageType as AlertColor} variant="standard" sx={{ width: '100%' }}>
        {userMessage}
      </Alert>
    </Snackbar>
  );
}

export default MessageToast;
